import React from "react";
import { SectionHeader } from "@/components/common/section-header";
import Image from "next/image";
import { Box, Grid, Stack } from "@mui/material";
import { CardGrid, Cards } from "@/types/dto/homepage/homepage-types";

interface CardGridSectionProps {
  cardGrid: CardGrid;
  moduleRanking: number;
  moduleName: string;
  parentContainerType?: string;
}

const CardGridSection = ({
  cardGrid,
  moduleRanking,
  moduleName,
  parentContainerType = "card grid"
}: CardGridSectionProps) => {
  const { basicInfo, cards } = cardGrid;
  return (
    <Box
      className="fluid-box"
      component="section"
      data-track="visibility"
      data-module-ranking-position={moduleRanking}
      data-module-name={moduleName}
      data-ranking-algorithm="manual"
      data-parent-container-type={parentContainerType}
      sx={{
        display: "flex",
        bgcolor: "info.light",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Stack
        p={{ xs: "4rem 2.4rem", sm: "4rem 3.2rem", lg: "6rem 10rem" }}
        className="full-width-container"
        spacing="4rem"
        justifyContent="center"
        alignItems="center"
      >
        <SectionHeader
          headerTestId="card-grid-header"
          headerText={basicInfo.headerText}
          headerSx={{
            textAlign: "center",
            color: "primary.main",
            fontSize: { xs: "2.6rem", sm: "2.8rem", md: "3.2rem" },
            textTransform: "none"
          }}
        />
        <Grid container rowSpacing="4rem" columnSpacing="2.4rem" justifyContent="center">
          {cards.map((card: Cards, index: number) => (
            <Grid key={card.id} size={{ xs: 12, md: 6 }}>
              <Stack spacing="1.6rem">
                <Stack direction="row" spacing="1.6rem" sx={{ alignItems: "center" }}>
                  <Image
                    src="/images/arrow_bullet.svg"
                    alt="arrow icon"
                    width={22}
                    height={22}
                    data-testid={`arrow-bullet-${index}`}
                  />
                  <SectionHeader
                    headerTestId={`card-header-${index}`}
                    headerText={card?.info?.headerText}
                    headerSx={{
                      fontSize: "1.8rem !important",
                      lineHeight: "2.6rem",
                      textTransform: "none",
                      color: "primary.main"
                    }}
                  />
                </Stack>
                <SectionHeader
                  copyTestId={`card-copy-${index}`}
                  copyText={card?.info?.copyText}
                  copySx={{
                    "& p": { margin: "0 !important" },
                    color: "primary.main",
                    lineHeight: "2.7rem",
                    fontSize: {xs:"1.6rem", md:"1.8rem"}
                  }}
                />
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  );
};

export default CardGridSection;
